import { Box, Typography, Link } from "@mui/material";
import { useLocation } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const location = useLocation();

  const excludedRoutes = ['/stick', '/schematicEditor'];
  if (excludedRoutes.includes(location.pathname)) {
    return null;
  }

  return (
    <Box component="footer" className="footer-container">
      <Typography  align="center">
        © {new Date().getFullYear()} <span className="sniglet-font-text">PHYtool</span>. All rights reserved.
      </Typography>
      <Typography sx={{ fontSize: 12 }} align="center">
        Designed by 
        <Link
          href="http://www.phyelements.com"
          target="_blank"
          underline="none"
          sx={{ ml: 0.5 }}
        >
          phyelements
        </Link>
      </Typography>
    </Box>
  );
}
